import { render } from "./ReconstructedAncestorsOverview.vue?vue&type=template&id=5c003a1a&scoped=true"
import script from "./ReconstructedAncestorsOverview.vue?vue&type=script&lang=js"
export * from "./ReconstructedAncestorsOverview.vue?vue&type=script&lang=js"

import "./ReconstructedAncestorsOverview.vue?vue&type=style&index=0&id=5c003a1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c003a1a"]])

export default __exports__